/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningListType } from './InternalApiScreeningListType';
import {
    InternalApiScreeningListTypeFromJSON,
    InternalApiScreeningListTypeFromJSONTyped,
    InternalApiScreeningListTypeToJSON,
    InternalApiScreeningListTypeToJSONTyped,
} from './InternalApiScreeningListType';
import type { InternalApiScreeningMatchType } from './InternalApiScreeningMatchType';
import {
    InternalApiScreeningMatchTypeFromJSON,
    InternalApiScreeningMatchTypeFromJSONTyped,
    InternalApiScreeningMatchTypeToJSON,
    InternalApiScreeningMatchTypeToJSONTyped,
} from './InternalApiScreeningMatchType';

/**
 * 
 * @export
 * @interface InternalApiScreeningManualSearchConfiguration
 */
export interface InternalApiScreeningManualSearchConfiguration {
    /**
     * 
     * @type {InternalApiScreeningListType}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    type: InternalApiScreeningListType;
    /**
     * 
     * @type {InternalApiScreeningMatchType}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    matchType: InternalApiScreeningMatchType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    listId?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    usableFieldId?: string;
    /**
     * Score threshold
     * @type {number}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    score?: number;
    /**
     * Prefix match limit
     * @type {number}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    prefixMatchLimit?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningManualSearchConfiguration
     */
    selectorGroupCodes?: Array<string>;
}



/**
 * Check if a given object implements the InternalApiScreeningManualSearchConfiguration interface.
 */
export function instanceOfInternalApiScreeningManualSearchConfiguration(value: object): value is InternalApiScreeningManualSearchConfiguration {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('matchType' in value) || value['matchType'] === undefined) return false;
    return true;
}

export function InternalApiScreeningManualSearchConfigurationFromJSON(json: any): InternalApiScreeningManualSearchConfiguration {
    return InternalApiScreeningManualSearchConfigurationFromJSONTyped(json, false);
}

export function InternalApiScreeningManualSearchConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningManualSearchConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'type': InternalApiScreeningListTypeFromJSON(json['type']),
        'matchType': InternalApiScreeningMatchTypeFromJSON(json['matchType']),
        'listId': json['listId'] == null ? undefined : json['listId'],
        'usableFieldId': json['usableFieldId'] == null ? undefined : json['usableFieldId'],
        'score': json['score'] == null ? undefined : json['score'],
        'prefixMatchLimit': json['prefixMatchLimit'] == null ? undefined : json['prefixMatchLimit'],
        'selectorGroupCodes': json['selectorGroupCodes'] == null ? undefined : json['selectorGroupCodes'],
    };
}

export function InternalApiScreeningManualSearchConfigurationToJSON(json: any): InternalApiScreeningManualSearchConfiguration {
    return InternalApiScreeningManualSearchConfigurationToJSONTyped(json, false);
}

export function InternalApiScreeningManualSearchConfigurationToJSONTyped(value?: InternalApiScreeningManualSearchConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': InternalApiScreeningListTypeToJSON(value['type']),
        'matchType': InternalApiScreeningMatchTypeToJSON(value['matchType']),
        'listId': value['listId'],
        'usableFieldId': value['usableFieldId'],
        'score': value['score'],
        'prefixMatchLimit': value['prefixMatchLimit'],
        'selectorGroupCodes': value['selectorGroupCodes'],
    };
}

